exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "table[data-v-39a81437],td[data-v-39a81437],th[data-v-39a81437]{border:1px solid #ddd}table[data-v-39a81437]{width:100%}td[data-v-39a81437],th[data-v-39a81437]{text-align:center!important;padding:8px}th[data-v-39a81437]{background-color:#eee}.use-color[data-v-39a81437]{color:#ff0303}", ""]);

// exports
